import {mixed} from 'yup';
import {TIMERS} from '../../../business/keys';

export default {
  timerName: mixed().required().oneOf(TIMERS,
    'The name used is not a valid timer to measure.',
  ),
};

// break cache